<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/project/assignTeam/${this.projectId}`">
      </f7-nav-left>
      <f7-nav-title>选择队伍</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="save">&nbsp;确定</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <f7-searchbar
        custom-search
        disable-button-text="取消"
        placeholder="队伍名字"
        @searchbar:search="searchTeamList"
        style="background-color: #ffffff;">
      </f7-searchbar>
      <div>
        <f7-row no-gap>
          <f7-col style="padding-right: 0.1rem;">
            <f7-list>
              <f7-list-item
                title="队伍类型"
                link=""
                @click="teamPopupOpened = true"
                :class="bgClass">
                <f7-icon icon="icon" slot="media"></f7-icon>
                <div slot="after">{{ teamDisplay }}</div>
                <f7-popup :opened="teamPopupOpened" @popup:closed="teamPopupOpened = false">
                  <popup-radio
                    title="队伍类型"
                    :data="companyTypeList"
                    :result.sync="search.companyType">
                  </popup-radio>
                </f7-popup>
              </f7-list-item>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list>
              <f7-list-item
                title="专业特长"
                link=""
                @click="featuresPopupOpened = true"
                :class="bgClass">
                <f7-icon icon="icon" slot="media"></f7-icon>
                <div slot="after">{{ featuresDisplay }}</div>
                <f7-popup :opened="featuresPopupOpened" @popup:closed="featuresPopupOpened = false">
                  <popup-radio
                    search="true"
                    title="专业特长"
                    :data="featuresList"
                    :result.sync="search.features">
                  </popup-radio>
                </f7-popup>
              </f7-list-item>
            </f7-list>
          </f7-col>
        </f7-row>
      </div>
      <div class="team-list">
        <div class="team-row" v-for="item in teamList" :key="item.id">
          <div style="width: 1.35rem; padding-right: 0.5rem;">
            <f7-radio
              color="orange"
              name="workerId"
              :value="item.id"
              :checked="teamId === item.id"
              @change="teamId = $event.target.value">
            </f7-radio>
          </div>
          <div class="team-text">
            <f7-link @click="callTeamDetail(item.id)">
              <div style="display: flex; align-items: start;">
                <div style="color: #000000;">{{ item.companyName }}</div>
                <competitiveness :score="item.score"></competitiveness>
                <div>
                  <img
                    class="team-type-img"
                    src="@/assets/img/ziyou.png"
                    v-if="item.companyRole === 'ownTeam'" />
                  <img
                    class="team-type-img"
                    src="@/assets/img/hezuo.png"
                    v-if="item.companyRole === 'cooperation'" />
                </div>
              </div>
              <div class="team-text-sub">
                <f7-row no-gap style="padding: 0.5rem 0rem;">
                  <f7-col>
                    <div class="team-auth" v-if="item.authentication">
                      <span>
                        <f7-icon size="0.8rem" material="verified_user" color="red"></f7-icon>
                      </span>
                      <span>已认证</span>
                    </div>
                    <span class="team-text-type">
                      {{ item.featureDescs.join('/') }}&nbsp;
                    </span>
                  </f7-col>
                </f7-row>
                <f7-row no-gap>
                  <f7-col>
                    <span class="team-text-label">工人</span>
                    <span class="team-text-value">{{ item.companyScale || '--' }} &nbsp;</span>
                    <span class="team-text-label">当前任务</span>
                    <span class="team-text-value">{{ item.taskCount || 0 }} &nbsp;</span>
                    <span class="team-text-label">地区</span>
                    <span class="team-text-value">
                      {{ item.serviceAreas.map(sa => sa.attrValueDesc).join(',') }}
                    </span>
                  </f7-col>
                </f7-row>
              </div>
            </f7-link>
          </div>
          <div class="team-after">
            <div style="width: 3.5rem;">
              <f7-link :href="`tel:${item.contactpeoplePhone}`">
                <span class="team-phone">
                  <span style="color: #000000; font-size: 1rem;">
                    {{ item.contactpeopleName }}
                  </span>
                  <f7-icon size="2rem" fa="phone"></f7-icon>
                </span>
              </f7-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import bus from '@/util/bus';
import { toTeamDetail } from '@/util/native';
import { createToast } from '@/util/compUtils';
import { getDict } from '@/api/common';
import { getTeamList, getTeam, saveTeam } from '@/api/team/worker';
import { getExtendedNodePath } from '@/util/treeUtils';
import PopupRadio from '@/components/PopupRadio';
import Competitiveness from '@/components/Competitiveness';

export default {
  props: ['projectId'],
  components: {
    PopupRadio,
    Competitiveness,
  },
  data() {
    return {
      bgClass: 'default-bg-color',
      teamPopupOpened: false,
      featuresPopupOpened: false,
      companyTypeList: [],
      featuresList1: [],
      featuresList2: [],
      teamId: '',
      teamList: [],
      search: {
        projectId: this.projectId,
        name: '',
        features: '',
        companyType: '',
      },
    };
  },
  created() {
    Promise.all([
      getTeam({ projectId: this.projectId }).then((result) => {
        if (result.code === 0) {
          this.teamId = ((result.data || {}).id) || '';
        }
      }),
      getDict({ typeCodes: ['companyType'] }).then((result) => {
        this.companyTypeList = result.data.companyType.codeVoList || [];
      }),
      getDict({ typeCodes: ['laborBizScope'] }).then((result) => {
        this.featuresList2 = result.data.laborBizScope.codeVoList || [];
      }),
      getDict({ typeCodes: ['professBizScope'] }).then((result) => {
        this.featuresList1 = result.data.professBizScope.codeVoList || [];
      }),
    ]).then(() => this.getList());
    this.debouncedGetList = lodash.debounce(this.getList, 500);
  },
  computed: {
    teamDisplay() {
      return this.companyTypeList
        .filter(item => item.code === this.search.companyType)
        .map(item => item.name)
        .join(',');
    },
    featuresDisplay() {
      return this.featuresList
        .filter(item => item.code === this.search.features)
        .map(item => item.name)
        .join(',');
    },
    featuresList() {
      if (this.search.companyType === 'specialtyTeam'
        || this.search.companyType === 'specialtyCompany') {
        return this.featuresList1;
      } else if (this.search.companyType === 'laborCompany'
        || this.search.companyType === 'integrateLaborTeam') {
        return this.featuresList2;
      } else if (this.search.companyType === 'buildingCompany') {
        return [];
      }
      return [];
    },
  },
  watch: {
    search: {
      handler: function debGet() { this.debouncedGetList(); },
      deep: true,
    },
  },
  methods: {
    callTeamDetail(id) {
      toTeamDetail(id);
    },
    handleDict(arr) {
      const root = {
        children: arr,
        code: '',
        name: '',
      };
      return getExtendedNodePath(root).map(item => ({
        code: item[item.length - 1].code,
        name: item.map(it => it.name).join('/'),
      }));
    },
    save() {
      if (lodash.isEmpty(this.teamList) || lodash.isEmpty(this.teamId)) {
        createToast(this, '请选择队伍');
        return;
      }
      this.$f7.dialog.confirm('确认要指定此队伍吗？', () => {
        const params = { projectId: this.projectId, selectedId: this.teamId };
        saveTeam(params).then((result) => {
          if (result.code === 0) {
            bus.$emit('refreshAssign');
            createToast(this, '指派队伍成功');
          }
        });
      });
    },
    getList() {
      getTeamList(this.search).then((result) => {
        if (result.code === 0) {
          this.teamList = result.data || [];
        }
      });
    },
    // clearSearch(searchbar) {
    //   searchbar.disable();
    // },
    searchTeamList(searchbar, query, previousQuery) {
      if (query !== previousQuery) {
        this.search.name = query;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .team-list {
    padding: 0.5rem 0rem;
  }

  .team-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0rem;
    border-bottom: 0.05rem solid $border-color;
  }

  .team-avatar {
    width: 2.5rem;
    margin-right: 0.5rem;
    text-align: center;
  }

  .team-text {
    font-size: 1rem;
    width: 100%;
  }

  .team-auth {
    min-width: 2.5rem;
    margin-right: 0.3rem;
    margin-left: 1rem;
    margin-top: 0.2rem;
    padding: 0rem 0.2rem;
    height: 1rem;
    font-size: 0.8rem;
    border: 0.05rem solid $red-color;
    border-radius: 0.2rem;
  }

  .team-text-sub {
    font-size: 0.8rem;
  }

  .team-text-type {
    /* background-color: #EEEEEE;
    border-radius: 0.2rem;
    padding: 0rem 0.2rem; */
    height: 150%;
    color: #999999;
  }

  .team-text-label {
    color: #999999;
  }

  .team-text-value {
    color: #FF9403;
  }

  .team-type-img {
    padding: 0.1rem 0.2rem 0.1rem 0.5rem;
    width: 1.2rem;
    height: 1.2rem;
  }

  .team-after {
    display: flex;
    align-items:center;
    justify-content:center;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    color: #FF9403;
    font-size: 0.6rem;
    text-align: center;
  }

  .team-phone {
    color: #FF9403;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/teamList.vue